/*
  Updates the price block on product pages (sections/product-template.liquid,
  [data-b2b-variant-price]) when another variant is selected. The prices per
  variant, including B2B Wholesale Hub prices, come from the JSON the section
  renders (snippets/b2b-variant-prices.liquid); theme.js only knows Shopify's
  list prices.
*/
(function () {
  var VAT = 1.19;
  var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function euros(cents) {
    return money.format(Math.round(cents) / 100);
  }

  function render(block, data) {
    var html = '';
    if (data.compare_at_price > data.price) {
      var percent = Math.round((1 - data.price / data.compare_at_price) * 100);
      html +=
        '<span class="b2b-price__was"><s>' +
          euros(data.compare_at_price) + ' netto (' + euros(data.compare_at_price * VAT) + ' inkl. MwSt.)</s>' +
          (percent > 0 ? ' <span class="b2b-price__badge">−' + percent + ' %</span>' : '') +
        '</span>' +
        '<span class="b2b-price__now"><span class="b2b-price__label">' + block.dataset.b2bLabel + '</span> ' +
          euros(data.price) + ' netto</span>';
    } else {
      html += '<span class="b2b-price__now b2b-price__now--regular">' + euros(data.price) + ' netto</span>';
    }
    html += '<span class="b2b-price__gross">(' + euros(data.price * VAT) + ' inkl. MwSt.)</span>';
    block.innerHTML = html;
    block.setAttribute('content', (data.price / 100).toFixed(2));
  }

  function update(container, variantId) {
    var block = container.querySelector('[data-b2b-variant-price]');
    var json = container.querySelector('script[id^="B2BVariantPrices-"]');
    if (!block || !json || !variantId) return;
    var prices = JSON.parse(json.textContent);
    if (prices[variantId]) render(block, prices[variantId]);
  }

  // theme.js triggers 'variantChange' (jQuery) on the product section
  if (window.jQuery) {
    window.jQuery(document).on('variantChange', function (evt) {
      if (evt.variant) update(evt.target.closest('[data-section-type="product"]') || document, evt.variant.id);
    });
  }
})();
